export default "__VITE_ASSET__C$Odc6Jy__"